import { getLanguageKey } from 'src/utils/localStorage';

// 判断文案是否为国内版本 - 从浏览器local里判断
export const isLanguageCN = () => {
  return getLanguageKey() === 'zh-CN';
};

// 判断功能是否为国内版本 - 从环境变量判断
export const isFunctionCN = () => {
  return process.env.REACT_APP_CURRENT_LANG === 'zh-CN';
};
